import { NgFor, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent, HeadlineComponent, TextComponent } from '@zeiss/beyond-online-angular';
import { RawCountrySpecificSetting } from 'src/app/state-management/types/configuration.type';
import { PopUpConfig, PopUpRef } from 'vis-ods-angular';
import { MOCK_STORAGE } from '../../../../../testing/mock-switch/mock-switch.component';

@Component({
	selector: 'app-mock-settings-popup',
	templateUrl: './mock-settings-popup.component.html',
	imports: [ReactiveFormsModule, HeadlineComponent, TextComponent, ButtonComponent, NgIf, NgFor],
})
export class MockSettingsPopupComponent {
	private mockStorage = inject(MOCK_STORAGE);

	countrySpecificSettings = (this.mockStorage.value()?.values || []).sort((a, b) =>
		a.name.localeCompare(b.name),
	);

	constructor(
		public popUpConfig: PopUpConfig<{ headline: string }>,
		private readonly popUpRef: PopUpRef,
	) {}

	editSetting(setting: RawCountrySpecificSetting, value: any) {
		this.countrySpecificSettings.forEach((s) => {
			if (s.name === setting.name) {
				s.value = value;
			}
		});
	}

	saveMockSettings() {
		this.mockStorage.setValue({
			mockMode: this.mockStorage.value()?.mockMode ?? false,
			values: this.countrySpecificSettings,
		});
		this.popUpRef.close();
		window.location.reload();
	}
}
